import {
  overlay,
  type OverlayAsyncControllerComponent,
  type OverlayControllerComponent,
} from 'overlay-kit';

// 고정 overlayId 는 이 파일로만 연다 — lint(zep/no-restricted-syntax)가 직접 지정을 막는다.
// overlay-kit 은 열린 id 를 다시 open 하면 렌더 중 throw 해 전역 에러 화면으로 간다(QUIZ-APP-5WA).
// close 직후 open 은 기존 항목 재오픈으로 처리돼 열린 모달이 그대로 남는다(새 controller 는 버려짐).

export function openOverlayOnce(
  overlayId: string,
  controller: OverlayControllerComponent,
) {
  overlay.close(overlayId);
  const options = { overlayId };
  return overlay.open(controller, options);
}

export function openOverlayOnceAsync<T>(
  overlayId: string,
  controller: OverlayAsyncControllerComponent<T>,
) {
  overlay.close(overlayId);
  const options = { overlayId };
  return overlay.openAsync<T>(controller, options);
}

/** 준비 중인 overlayId. 진입점이 여러 곳이어도 하나로 막으려고 모듈에 둔다. */
const preparingOverlayIds = new Set<string>();

/**
 * overlayId 당 모달 준비(코드·데이터 받기)를 한 번에 하나만 실행한다. 준비 중에 다시
 * 부르면 task 를 실행하지 않고 `null` 을 돌려준다(건너뛰었다는 뜻 — task 결과와 구분된다).
 * 느린 망에서 연타해도 요청·트래킹이 겹치지 않게 하되, 화면이 아니라 함수 입구에서 막아
 * 입력 방식·모달 안팎과 무관하다.
 *
 * 준비가 끝나면 바로 푼다 — 닫힐 때까지 잡으면 페이지 이동 때 `GlobalDialogManager` 가
 * overlay 를 모두 지워 닫힘 promise 가 끝나지 않아 다시 열 수 없다. 이어지는 open 은
 * 마이크로태스크라 그 사이에 클릭이 끼어들지 않는다.
 */
export async function prepareOverlayOnce<T>(
  overlayId: string,
  task: () => Promise<T>,
): Promise<T | null> {
  if (preparingOverlayIds.has(overlayId)) return null;
  preparingOverlayIds.add(overlayId);
  try {
    return await task();
  } finally {
    preparingOverlayIds.delete(overlayId);
  }
}
